import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_NodeViewWrapper = _resolveComponent("NodeViewWrapper");
    const _directive_tooltip = _resolveDirective("tooltip");
    return _withDirectives((_openBlock(), _createBlock(_component_NodeViewWrapper, {
        class: _normalizeClass([
            'merge-tag',
            `${_ctx.mergeTagType}-tag`,
            {
                'is-selected': _ctx.selected,
                'value-empty': _ctx.isMergeValueEmpty,
                'placeholder-state': _ctx.mergeValue() === _ctx.mergeTagPlaceholder,
            },
        ]),
        "merge-key": _ctx.mergeKeyAttribute,
        category: _ctx.categoryAttribute,
        "custom-name": _ctx.customName,
        "tag-id": _ctx.tagId,
        "data-external": `editor-merge-tag-${_ctx.mergeTagType}-${_ctx.mergeLabel}-id-${_ctx.tagId}`,
        onDblclick: _ctx.openMenu,
        onClick: _ctx.selectMergeTag
    }, {
        default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.mergeValue()), 1)
        ]),
        _: 1
    }, 8, ["class", "merge-key", "category", "custom-name", "tag-id", "data-external", "onDblclick", "onClick"])), [
        [_directive_tooltip, Object.assign(Object.assign({}, _ctx.toolTipOptions), { content: _ctx.tooltipContent })]
    ]);
}
